module.exports = __webpack_public_path__ + "img/corner-up-right.b2d9dd71.svg";